import React, { useState, useRef, useCallback, useEffect, memo } from "react";
import {
  Text,
  Col,
  Button,
  PageView,
  Table,
  Input,
  Dropdown,
  Dialog,
  DatePicker,
} from "components/YeyComponents";
import { colors } from "utils/StyleUtils";
import api from "services/api";
import {
  statusLOV,
  paginationLimit,
  queryParamsConstructor,
} from "utils/Utils";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useHistory, useLocation } from "react-router-dom";
import {
  Menu,
  MenuItem,
  Divider,
  ListSubheader,
  Grid,
} from "@material-ui/core";
import {
  downloadContractObject,
  downloadCustomerEvaluationForm,
  downloadContractTerminationCalc,
  downloadContractTerminationTerm,
  downloadContractDismissalLetter,
  downloadContractExtensionTerm,
  downloadContractAgreeTerm,
  downloadPayslipObject,
  downloadActivityPlanForm,
} from "redux/actions/report";
import { useDispatch, useSelector } from "react-redux";
import { loadAllCombos } from "redux/actions/combos";
import toast from "react-hot-toast";
import errorHandler from "utils/errorHandler";
import BRLCurrencyConverter from "utils/BRLCurrencyConverter";

const HOUR_IN_MILISECONDS = 1000 * 60 * 60;
const DAY_IN_MILISECONDS = 1000 * 60 * 60 * 24;
const MONTH_IN_MILISECONDS = DAY_IN_MILISECONDS * 30;

const Contrato = () => {
  const location = useLocation();
  const combos = useSelector((state) => state.combos);
  const defaultFilterValues = [
    { name: "id", operator: "contains", type: "string" },
    { name: "customerName", operator: "contains", type: "string" },
    { name: "companyName", operator: "contains", type: "string" },
    { name: "schoolName", operator: "contains", type: "string" },
    { name: "startDate", operator: "eq", type: "string" },
    {
      name: "endDate",
      operator: "eq",
      type: "string",
      value: location?.state?.defaultEndDateValue,
    },
    {
      name: "status",
      operator: "eq",
      type: "string",
      value: location?.state?.defaultStatusValue,
    },
  ];
  const [newFilterValue, setNewFilterValue] = useState(defaultFilterValues);
  const [limit, setLimit] = useState(paginationLimit);
  const [gridRef, setGridRef] = useState(null);

  const [isExtendContractDialogVisible, setIsExtendContractDialogVisible] =
    useState(false);
  const [isPayslipDialogVisible, setIsPayslipDialogVisible] = useState(false);
  const [isTerminationCalcDialogVisible, setIsTerminationCalcDialogVisible] =
    useState(false);
  const [isEvaluationDialogVisible, setIsEvaluationDialogVisible] =
    useState(false);
  const [isRevocationDialogVisible, setIsRevocationDialogVisible] =
    useState(false);
  const [isStatusDialogVisible, setIsStatusDialogVisible] = useState(false);

  let selectedContractId = useRef();
  let selectedContractValue = useRef({ data: null, index: null, status: null });

  const history = useHistory();
  const dispatch = useDispatch();

  const loadData = (props = {}) => {
    const {
      skip = 0,
      sortInfo = "",
      groupBy = "",
      filterValue = newFilterValue,
    } = props;

    const queryParams = queryParamsConstructor({
      limit,
      skip,
      sortInfo,
      groupBy,
      filterValue,
    });

    return api.get("contracts", { params: queryParams }).then((response) => {
      const totalCount = response.data.total;
      return {
        data: response?.data?.contracts?.map((c) => {
          c.wage = Number(c.wage).toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
          });
          c.status = c.status.label;
          c.startDate = new Date(c?.startDate).toLocaleDateString("pt-BR");
          c.endDate = new Date(c?.endDate).toLocaleDateString("pt-BR");

          return c;
        }),
        count: totalCount * 1,
      };
    });
  };

  const dataSource = useCallback(loadData, [newFilterValue, limit]);

  const ActionComponent = memo(({ data }) => {
    const [isMenuVisible, setIsMenuVisible] = useState(null);

    const handleClick = (event) => {
      setIsMenuVisible(event?.currentTarget);
    };

    const handleClose = () => {
      setIsMenuVisible(false);
    };

    const downloadContract = () => {
      setIsMenuVisible(false);
      dispatch(downloadContractObject(data?.id));
    };

    const editContract = () => {
      setIsMenuVisible(false);
      // history.push(`contratos/editar/${data?.id}`)
      history.push({ pathname: `contratos/${data?.id}` });
    };

    const generateReport = () => {
      selectedContractId.current = data?.id;
      setIsMenuVisible(false);
      setIsEvaluationDialogVisible(true);
    };

    const generateContractActivityPlan = () => {
      setIsMenuVisible(false);
      dispatch(downloadActivityPlanForm(data?.id));
    };

    const generateContractDismissalLetter = () => {
      setIsMenuVisible(false);
      dispatch(downloadContractDismissalLetter(data?.id));
    };
    const generateContractAgreeTerm = () => {
      setIsMenuVisible(false);
      dispatch(downloadContractAgreeTerm(data?.id));
    };
    const generateContractExtensionTerm = () => {
      setIsMenuVisible(false);
      dispatch(downloadContractExtensionTerm(data?.id));
    };
    const generateTerminationTerm = () => {
      setIsMenuVisible(false);
      dispatch(downloadContractTerminationTerm(data?.id));
    };

    const showExtendContractDialog = () => {
      setIsMenuVisible(false);
      selectedContractId.current = data?.id;
      setIsExtendContractDialogVisible(true);
    };
    const showPayslipDialog = () => {
      setIsMenuVisible(false);
      selectedContractId.current = data?.id;
      setIsPayslipDialogVisible(true);
    };
    const showTerminationCalcDialog = () => {
      setIsMenuVisible(false);
      selectedContractId.current = data?.id;
      setIsTerminationCalcDialogVisible(true);
    };

    let reportsStatusList = [
      {
        label: "Holerite",
        onClick: showPayslipDialog,
        condition: !["Rescindido", "Encerrado", "Cancelado"].includes(
          data?.status
        ),
      },
      {
        label: "Plano de Atividade",
        onClick: generateContractActivityPlan,
        condition: !["Rescindido", "Encerrado", "Cancelado"].includes(
          data?.status
        ),
      },
      {
        label: "Ficha de Avaliação",
        onClick: generateReport,
        condition: !["Rescindido", "Encerrado", "Cancelado"].includes(
          data?.status
        ),
      },
      {
        label: "Termo de Concordância",
        onClick: generateContractAgreeTerm,
        condition: !["Rescindido", "Encerrado", "Cancelado"].includes(
          data?.status
        ),
      },
      {
        label: "Termo de Prorrogação",
        onClick: generateContractExtensionTerm,
        condition: ["Ativo"].includes(data?.status) && data?.extensionDate,
      },
      {
        label: "Carta de Dispensa",
        onClick: generateContractDismissalLetter,
        condition: ["Rescindido"].includes(data?.status),
      },
      {
        label: "Termo de Rescisão",
        onClick: generateTerminationTerm,
        condition: ["Rescindido"].includes(data?.status),
      },
      {
        label: "Calculo de Rescisão",
        onClick: showTerminationCalcDialog,
        condition: ["Rescindido"].includes(data?.status),
      },
    ];

    return (
      <>
        <div id="action" onClick={handleClick}>
          <BsThreeDotsVertical size={20} />
        </div>
        <Menu
          id="simple-menu"
          anchorEl={isMenuVisible}
          keepMounted
          open={Boolean(isMenuVisible)}
          onClose={handleClose}
        >
          <MenuItem onClick={downloadContract}>Baixar Contrato</MenuItem>
          <MenuItem onClick={editContract}>Editar Contrato</MenuItem>
          {["Ativo"].includes(data?.status) && (
            <MenuItem onClick={showExtendContractDialog}>
              Prorrogar Contrato
            </MenuItem>
          )}
          {(() => {
            let reports = reportsStatusList.map((report) => {
              if (report.condition) {
                return (
                  <MenuItem key={report.label} onClick={report.onClick}>
                    {report.label}
                  </MenuItem>
                );
              }
              return null;
            });
            reports = reports.filter((report) => report !== null);
            return reports.length > 0 ? (
              <>
                <Divider />
                <ListSubheader>Relatórios / Fichas</ListSubheader>
                {reports}
              </>
            ) : null;
          })()}
        </Menu>
      </>
    );
  });

  const StatusDropdownComponent = memo(({ data, columnIndex, rowIndex }) => {
    const [selectedStatus, setSelectedStatus] = useState({});
    const [statusData, setStatusData] = useState([]);

    const refMainView = useRef();

    useEffect(() => {
      if (data?.status) {
        const selectedStatusObject = statusLOV.find(
          (element) => element?.label === data?.status
        );
        if (selectedStatusObject) {
          setSelectedStatus(selectedStatusObject);
        }
      }
    }, [data]);

    useEffect(() => {
      let statusDataArray = [];
      if (
        selectedStatus?.acceptedValues &&
        Array.isArray(selectedStatus?.acceptedValues) &&
        selectedStatus?.acceptedValues?.length > 0
      ) {
        selectedStatus?.acceptedValues?.forEach((acceptedStatusValue) => {
          const foundStatus = statusLOV.find(
            ({ value }) => value === acceptedStatusValue
          );
          statusDataArray.push(foundStatus);
        });
      }
      setStatusData(statusDataArray);
    }, [selectedStatus]);

    const onChangeStatus = (newValue) => {
      selectedContractValue.current = {
        ...selectedContractValue.current,
        index: rowIndex,
        status: newValue,
      };
      selectedContractId.current = data?.id;

      if (newValue?.value !== selectedStatus?.value) {
        if (newValue?.value !== "revoked") {
          setIsStatusDialogVisible(true);
        } else setIsRevocationDialogVisible(true);
      }
    };

    //console.log('gridRef', gridRef?.current)
    //console.log('bodyRef grid', gridRef?.current?.bodyRef?.current)
    // console.log('bodyRef portalRef', gridRef?.current?.portalRef?.current?.domNode) // nao visivel
    // console.log('bodyRef portalRef', gridRef?.current?.portalRef?.current?.offsetParent) // nao visivel
    // console.log('bodyRef bodyRef', gridRef?.current?.domRef?.current) // nao resolve
    // console.log('bodyRef document', document.body)
    // parentElement
    // parentNode

    return (
      <div id="divR" ref={refMainView}>
        {selectedStatus && gridRef?.current?.bodyRef?.current && (
          <Dropdown
            width="100%"
            // values={statusLOV} // Testes para mudanca de status
            values={statusData}
            // selectedValues={
            //     statusData.filter(option =>
            //         option.label === data?.status)
            // }
            selectedValues={[selectedStatus]}
            onChangeValue={onChangeStatus}
            maxWidth="100%"
            minWidth="100%"
            flex={1}
            closeMenuOnSelect={true}
            menuPortalTarget={document.body}
            menuPosition="fixed"
          />
        )}
      </div>
    );
  });

  const TerminationCalcDialog = () => {
    const [state, setState] = useState({
      addendum: null,
      addendum_ref: null,
      voucher: null,
      voucher_ref: null,
      voucher_shopping: null,
      voucher_shopping_ref: null,
      absence: null,
      bonus: null,
      bonus_ref: null,
      reward: null,
      reward_ref: null,
      award: null,
      award_ref: null,
      remuneration: null,
      remuneration_ref: null,
      vacations: null,
      vacations_ref: null,
    });

    useEffect(async () => {
      if (!isTerminationCalcDialogVisible) return;
      const data = await api
        .get(`contract/${selectedContractId?.current}`)
        .then(async (response) => response.data)
        .catch((err) => {
          console.log(err);
          toast.error(`Erro ao encontrar contrato: ${errorHandler(err)}`);
        });
      const HOURS_DIFF = 3 * HOUR_IN_MILISECONDS;
      const revokedAt = new Date(data?.revokedAt);
      revokedAt.setTime(revokedAt.getTime() + HOURS_DIFF);
      const startDate = new Date(data?.startDate);
      startDate.setTime(startDate.getTime() + HOURS_DIFF);
      // Wage Calc
      const diff =
        revokedAt - new Date(revokedAt.getFullYear(), revokedAt.getMonth(), 1);
      const diffWageDays = Math.min(Math.ceil(diff / DAY_IN_MILISECONDS), 30);

      const wage = data?.wage
        ? Math.floor((data.wage / 30) * diffWageDays * 100) / 100
        : null;

      // Vacation Calc
      const diffVacations = revokedAt - startDate;
      let diffVacationsMonths = Math.max(
        parseInt(diffVacations / MONTH_IN_MILISECONDS),
        0
      );
      diffVacationsMonths =
        diffVacationsMonths === 0 && diffVacations / DAY_IN_MILISECONDS > 16
          ? 1
          : diffVacationsMonths;

      const vacations = data?.wage
        ? Math.floor((data.wage / 12) * diffVacationsMonths * 100) / 100
        : null;

      setState((prevState) => ({
        ...prevState,
        remuneration:
          wage && wage > 0.0
            ? BRLCurrencyConverter(String(wage.toFixed(2)))
            : null,
        vacations: BRLCurrencyConverter(String(vacations.toFixed(2))),
        vacations_ref: `(${diffVacationsMonths}/12)`,
      }));
    }, [isTerminationCalcDialogVisible]);

    const onSubmit = () => {
      dispatch(
        downloadContractTerminationCalc(selectedContractId.current, {
          remuneration_ref: state?.remuneration_ref,
          award_ref: state?.award_ref,
          reward_ref: state?.reward_ref,
          bonus_ref: state?.bonus_ref,
          voucher_shopping_ref: state?.voucher_shopping_ref,
          voucher_ref: state?.voucher_ref,
          addendum_ref: state?.addendum_ref,
          vacations_ref: state?.vacations_ref,
          remuneration: state?.remuneration
            ? Number(state?.remuneration.replace(".", "").replace(",", "."))
            : null,
          vacations: state?.vacations
            ? Number(state?.vacations.replace(".", "").replace(",", "."))
            : null,
          addendum: state?.addendum
            ? Number(state?.addendum.replace(".", "").replace(",", "."))
            : null,
          voucher: state?.voucher
            ? Number(state?.voucher.replace(".", "").replace(",", "."))
            : null,
          voucher_shopping: state?.voucher_shopping
            ? Number(state?.voucher_shopping.replace(".", "").replace(",", "."))
            : null,
          absence: state?.absence ? parseInt(state?.absence) : null,

          bonus: state?.bonus
            ? Number(state?.bonus.replace(".", "").replace(",", "."))
            : null,
          reward: state?.bonus
            ? Number(state?.reward.replace(".", "").replace(",", "."))
            : null,
          award: state?.award
            ? Number(state?.award.replace(".", "").replace(",", "."))
            : null,
        })
      );
      setIsTerminationCalcDialogVisible(false);
    };

    const onChangeCurrencyValue = (value, name) => {
      setState((prevState) => ({
        ...prevState,
        [name]: BRLCurrencyConverter(value),
      }));
    };

    const onChangeIntegerValue = (value, name, max) => {
      let parsedValue = parseInt(value);
      parsedValue = max ? Math.min(parsedValue, max) : parsedValue;
      setState((prevState) => ({
        ...prevState,
        [name]: parsedValue,
      }));
    };

    const onChangeStringValue = (value, name) => {
      setState((prevState) => ({
        ...prevState,
        [name]: String(value || "").trim(),
      }));
    };

    return (
      <Dialog
        title="Gerar Termo de Rescisão"
        text="Preencha o formulário abaixo para gerar o termo de rescisão do contrato"
        isVisible={isTerminationCalcDialogVisible}
        setIsVisible={setIsTerminationCalcDialogVisible}
        onClick={onSubmit}
      >
        <div>
          <Text type="label" style={{ marginBottom: "0.5em" }}>
            <b>Desconto(s)</b>
          </Text>
          <Grid container direction="row" alignItems="flex-start" spacing={2}>
            <Grid
              item
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              direction="column"
              spacing={2}
            >
              <Input
                style={{ flexDirection: "column" }}
                label="Adiantamento (R$)"
                placeholder="0,00"
                type="text"
                value={state.addendum}
                onChange={(e) =>
                  onChangeCurrencyValue(e.target.value, "addendum")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Vale Compras (R$)"
                placeholder="0,00"
                type="text"
                value={state.voucher_shopping}
                onChange={(e) =>
                  onChangeCurrencyValue(e.target.value, "voucher_shopping")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Vale (R$)"
                placeholder="0,00"
                type="text"
                value={state.voucher}
                onChange={(e) =>
                  onChangeCurrencyValue(e.target.value, "voucher")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Faltas (Dias)"
                placeholder="0"
                type="text"
                value={state.absence}
                onChange={(e) =>
                  onChangeIntegerValue(e.target.value, "absence", 30)
                }
              />
            </Grid>
            <Grid
              item
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              direction="column"
              spacing={2}
            >
              <Input
                style={{ flexDirection: "column" }}
                label="Adiantamento (Ref)"
                type="text"
                value={state.addendum_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "addendum_ref")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Vale Compras (Ref)"
                type="text"
                value={state.voucher_shopping_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "voucher_shopping_ref")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Vale (Ref)"
                type="text"
                value={state.voucher_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "voucher_ref")
                }
              />
            </Grid>
          </Grid>
          <br />
          <Divider />
          <br />
          <Text type="label">
            <b>Acréscimo(s)</b>
          </Text>
          <Grid container direction="row" alignItems="flex-start" spacing={2}>
            <Grid
              item
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              direction="column"
              spacing={2}
            >
              <Input
                style={{ flexDirection: "column" }}
                label="Bolsa Estágio (R$)"
                placeholder="0,00"
                type="text"
                value={state.remuneration}
                onChange={(e) =>
                  onChangeCurrencyValue(e.target.value, "remuneration")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Bônus (R$)"
                placeholder="0,00"
                type="text"
                value={state.bonus}
                onChange={(e) => onChangeCurrencyValue(e.target.value, "bonus")}
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Gratificação (R$)"
                placeholder="0,00"
                type="text"
                value={state.reward}
                onChange={(e) =>
                  onChangeCurrencyValue(e.target.value, "reward")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Premiação (R$)"
                placeholder="0,00"
                type="text"
                value={state.award}
                onChange={(e) => onChangeCurrencyValue(e.target.value, "award")}
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Férias (R$)"
                placeholder="0,00"
                type="text"
                value={state.vacations}
                onChange={(e) =>
                  onChangeCurrencyValue(e.target.value, "vacations")
                }
              />
            </Grid>
            <Grid
              item
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              direction="column"
              spacing={2}
            >
              <Input
                style={{ flexDirection: "column" }}
                label="Bolsa Estágio (Ref)"
                type="text"
                value={state.remuneration_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "remuneration_ref")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Bônus (Ref)"
                type="text"
                value={state.bonus_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "bonus_ref")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Gratificação (Ref)"
                type="text"
                value={state.reward_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "reward_ref")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Premiação (Ref)"
                type="text"
                value={state.award_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "award_ref")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Férias (Ref)"
                type="text"
                value={state.vacations_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "vacations_ref")
                }
              />
            </Grid>
          </Grid>
        </div>
      </Dialog>
    );
  };
  const PayslipDialog = () => {
    const [payslipDate, setPayslipDate] = useState(new Date());

    const [state, setState] = useState({
      addendum: null,
      addendum_ref: null,
      voucher: null,
      voucher_ref: null,
      voucher_shopping: null,
      voucher_shopping_ref: null,
      absence: null,
      bonus: null,
      bonus_ref: null,
      reward: null,
      reward_ref: null,
      award: null,
      award_ref: null,
      remuneration: null,
      remuneration_ref: null,
    });

    useEffect(async () => {
      if (!isPayslipDialogVisible) return;
      const data = await api
        .get(`contract/${selectedContractId?.current}`)
        .then(async (response) => response.data)
        .catch((err) => {
          console.log(err);
          toast.error(`Erro ao encontrar contrato: ${errorHandler(err)}`);
        });
      const wage = Number(data?.wage);
      setState((prevState) => ({
        ...prevState,
        remuneration:
          wage && wage > 0.0
            ? BRLCurrencyConverter(String(wage.toFixed(2)))
            : null,
      }));
    }, [isPayslipDialogVisible]);

    const onDateSelect = (newDate) => {
      setPayslipDate(newDate);
    };

    const onSubmit = () => {
      dispatch(
        downloadPayslipObject(
          selectedContractId.current,
          `${String(payslipDate.getMonth() + 1).padStart(
            2,
            "0"
          )}/${payslipDate.getFullYear()}`,
          {
            remuneration_ref: state?.remuneration_ref,
            award_ref: state?.award_ref,
            reward_ref: state?.reward_ref,
            bonus_ref: state?.bonus_ref,
            voucher_shopping_ref: state?.voucher_shopping_ref,
            voucher_ref: state?.voucher_ref,
            addendum_ref: state?.addendum_ref,
            remuneration: state?.remuneration
              ? Number(state?.remuneration.replace(".", "").replace(",", "."))
              : null,
            addendum: state?.addendum
              ? Number(state?.addendum.replace(".", "").replace(",", "."))
              : null,
            voucher: state?.voucher
              ? Number(state?.voucher.replace(".", "").replace(",", "."))
              : null,
            voucher_shopping: state?.voucher_shopping
              ? Number(
                  state?.voucher_shopping.replace(".", "").replace(",", ".")
                )
              : null,
            absence: state?.absence ? parseInt(state?.absence) : null,

            bonus: state?.bonus
              ? Number(state?.bonus.replace(".", "").replace(",", "."))
              : null,
            reward: state?.reward
              ? Number(state?.reward.replace(".", "").replace(",", "."))
              : null,
            award: state?.award
              ? Number(state?.award.replace(".", "").replace(",", "."))
              : null,
          }
        )
      );
      setIsPayslipDialogVisible(false);
    };

    const onChangeCurrencyValue = (value, name) => {
      setState((prevState) => ({
        ...prevState,
        [name]: BRLCurrencyConverter(value),
      }));
    };
    const onChangeIntegerValue = (value, name, max) => {
      let parsedValue = parseInt(value);
      parsedValue = max ? Math.min(parsedValue, max) : parsedValue;
      setState((prevState) => ({
        ...prevState,
        [name]: parsedValue,
      }));
    };
    const onChangeStringValue = (value, name) => {
      setState((prevState) => ({
        ...prevState,
        [name]: String(value || "").trim(),
      }));
    };
    return (
      <Dialog
        title="Gerar Holerite"
        text="Preencha o formulário abaixo para gerar o holerite do contrato"
        isVisible={isPayslipDialogVisible}
        setIsVisible={setIsPayslipDialogVisible}
        onClick={onSubmit}
      >
        <div>
          <DatePicker
            label="Mês/Ano do Holerite"
            onChangeValue={onDateSelect}
            value={payslipDate}
            readOnlyHandler={true}
            width="100%"
            dateFormat="MM/yyyy"
            showMonthYearPicker
            labelProps={{
              padding: { top: "1em", bottom: "0.5em" },
              size: "1em",
            }}
          />
          <br />
          <Divider />
          <br />
          <Text type="label" style={{ marginBottom: "0.5em" }}>
            <b>Desconto(s)</b>
          </Text>
          <Grid container direction="row" alignItems="flex-start" spacing={2}>
            <Grid
              item
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              direction="column"
              spacing={2}
            >
              <Input
                style={{ flexDirection: "column" }}
                label="Adiantamento (R$)"
                placeholder="0,00"
                type="text"
                value={state.addendum}
                onChange={(e) =>
                  onChangeCurrencyValue(e.target.value, "addendum")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Vale Compras (R$)"
                placeholder="0,00"
                type="text"
                value={state.voucher_shopping}
                onChange={(e) =>
                  onChangeCurrencyValue(e.target.value, "voucher_shopping")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Vale (R$)"
                placeholder="0,00"
                type="text"
                value={state.voucher}
                onChange={(e) =>
                  onChangeCurrencyValue(e.target.value, "voucher")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Faltas (Dias)"
                placeholder="0"
                type="text"
                value={state.absence}
                onChange={(e) =>
                  onChangeIntegerValue(e.target.value, "absence", 30)
                }
              />
            </Grid>
            <Grid
              item
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              direction="column"
              spacing={2}
            >
              <Input
                style={{ flexDirection: "column" }}
                label="Adiantamento (Ref)"
                type="text"
                value={state.addendum_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "addendum_ref")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Vale Compras (Ref)"
                type="text"
                value={state.voucher_shopping_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "voucher_shopping_ref")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Vale (Ref)"
                type="text"
                value={state.voucher_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "voucher_ref")
                }
              />
            </Grid>
          </Grid>
          <br />
          <Divider />
          <br />
          <Text type="label">
            <b>Acréscimo(s)</b>
          </Text>
          <Grid container direction="row" alignItems="flex-start" spacing={2}>
            <Grid
              item
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              direction="column"
              spacing={2}
            >
              <Input
                style={{ flexDirection: "column" }}
                label="Bolsa Estágio (R$)"
                placeholder="0,00"
                type="text"
                value={state.remuneration}
                onChange={(e) =>
                  onChangeCurrencyValue(e.target.value, "remuneration")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Bônus (R$)"
                placeholder="0,00"
                type="text"
                value={state.bonus}
                onChange={(e) => onChangeCurrencyValue(e.target.value, "bonus")}
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Gratificação (R$)"
                placeholder="0,00"
                type="text"
                value={state.reward}
                onChange={(e) =>
                  onChangeCurrencyValue(e.target.value, "reward")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Premiação (R$)"
                placeholder="0,00"
                type="text"
                value={state.award}
                onChange={(e) => onChangeCurrencyValue(e.target.value, "award")}
              />
            </Grid>
            <Grid
              item
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              direction="column"
              spacing={2}
            >
              <Input
                style={{ flexDirection: "column" }}
                label="Bolsa Estágio (Ref)"
                type="text"
                value={state.remuneration_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "remuneration_ref")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Bônus (Ref)"
                type="text"
                value={state.bonus_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "bonus_ref")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Gratificação (Ref)"
                type="text"
                value={state.reward_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "reward_ref")
                }
              />
              <Input
                style={{ flexDirection: "column" }}
                label="Premiação (Ref)"
                type="text"
                value={state.award_ref}
                onChange={(e) =>
                  onChangeStringValue(e.target.value, "award_ref")
                }
              />
            </Grid>
          </Grid>
        </div>
      </Dialog>
    );
  };
  
  const ExtendContractDialog = () => {
    const [selectedDate, setSelectedDate] = useState(
      new Date(new Date().getTime() + (12*MONTH_IN_MILISECONDS))
    );

    const onDateSelect = (newDate) => {
      setSelectedDate(newDate);
    };

    const onSubmit = () => {
      statusChangeHandler({
        status: "extended",
        extensionDate: selectedDate,
      });
      setIsExtendContractDialogVisible(false);
    };

    return (
      <Dialog
        title="Extensão contratual"
        text="Insira no campo abaixo o periodo a qual o contrato deve ser estendido"
        isVisible={isExtendContractDialogVisible}
        setIsVisible={setIsExtendContractDialogVisible}
        onClick={onSubmit}
      >
        <DatePicker
          label="Prorrogado até"
          onChangeValue={onDateSelect}
          value={selectedDate}
          readOnlyHandler={true}
          width="100%"
          labelProps={{
            padding: { top: "1em", bottom: "0.5em" },
            size: "1em",
          }}
        />
      </Dialog>
    );
  };

  const EvaluationDialog = () => {
    const [avaliationInputText, setAvaliationInputText] = useState("");
    const [evaluationDate, setEvaluationDate] = useState(new Date());
    const onDateSelect = (newDate) => {
      setEvaluationDate(newDate);
    };

    const getInputValue = (newValue) => {
      setAvaliationInputText(newValue);
    };

    const onSubmit = () => {
      dispatch(
        downloadCustomerEvaluationForm(
          selectedContractId.current,
          `${evaluationDate.getFullYear()} - ${avaliationInputText.value}`
        )
      );
      setIsEvaluationDialogVisible(false);
    };

    return (
      <Dialog
        title="Ficha de Avaliação"
        text="Insira no campo abaixo o periodo que deve ser passado para a ficha de avaliação"
        isVisible={isEvaluationDialogVisible}
        setIsVisible={setIsEvaluationDialogVisible}
        onClick={onSubmit}
        disabled={avaliationInputText.length === 0}
      >
        <DatePicker
          label="Ano da Avaliação"
          onChangeValue={onDateSelect}
          value={evaluationDate}
          readOnlyHandler={true}
          width="100%"
          dateFormat="yyyy"
          showYearPicker
          //dateFormat={dateFormat}
          //popperPlacement='top-end'
          labelProps={{
            padding: { top: "1em", bottom: "0.5em" },
            size: "1em",
          }}
        />
        <Dropdown
          label="Selecione um semestre"
          width="100%"
          values={
            new Array(
              ...[
                { label: "1ª Semestre", value: "1ª Semestre" },
                { label: "2ª Semestre", value: "2ª Semestre" },
              ]
            )
          }
          selectedValues={[avaliationInputText]}
          onChangeValue={(e) => getInputValue(e)}
          maxWidth="100%"
          minWidth="100%"
          //padding={{ top: '0.5em' }}
          flex={1}
          closeMenuOnSelect={true}
          menuPosition="fixed"
          labelProps={{
            padding: { top: "1em", bottom: "0.5em" },
            size: "1em",
          }}
        />
      </Dialog>
    );
  };

  const statusChangeHandler = (params) => {
    const status =
      params?.status || selectedContractValue.current?.status?.value;
    const contractId = selectedContractId.current;
    const revokedFlag = params?.revocationReason ? true : false;
    const extendedFlag = params?.status === "extended";

    if (!status) {
      toast.error("Selecione um status válido para o contrato.");
      return;
    }

    if (!contractId) {
      toast.error("Selecione um contrato válido.");
      return;
    }

    let toastId = toast.loading(`Atualizando status do contrato...`);
    const queryConfig = {
      params: {
        status: status,
        revocationReasonId: params?.revocationReason,
        revocationDate: params?.revocationDate,
        extensionDate: params?.extensionDate,
      },
    };

    api
      .patch(`contract/${contractId}/status`, {}, queryConfig)
      .then((response) => {
        toast.success(
          `Contrato ${revokedFlag ? "rescindido" : "atualizado"} com sucesso. `,
          response
        );

        if (revokedFlag) setIsRevocationDialogVisible(false);
        else if (extendedFlag) setIsExtendContractDialogVisible(false);
        else setIsStatusDialogVisible(false);

        if (!extendedFlag && selectedContractValue?.current) {
          gridRef?.current?.setItemAt(selectedContractValue.current?.index, {
            ...selectedContractValue.current?.data,
            status: selectedContractValue.current?.status?.label,
          });
        }
      })
      .catch((err) =>
        toast.error(`Erro ao atualizar valor: ${errorHandler(err)}`)
      )
      .finally(() => toast.dismiss(toastId));
  };

  const RevocationDialog = () => {
    const [revocationReason, setRevocationReason] = useState(null);
    const [revocationDate, setRevocationDate] = useState(new Date());

    const onSelectEvocation = (newValue) => {
      setRevocationReason(newValue);
    };

    const onDateSelect = (newDate) => {
      setRevocationDate(newDate);
    };

    const onSubmit = () => {
      statusChangeHandler({
        revocationReason: revocationReason?.value,
        revocationDate: revocationDate,
      });
    };

    return (
      <Dialog
        title="Rescisão de contrato"
        text="Preencha abaixo os dados referentes à rescisão do contrato"
        isVisible={isRevocationDialogVisible}
        setIsVisible={setIsRevocationDialogVisible}
        onClick={onSubmit}
        secondaryButtonOnClick={() => setIsRevocationDialogVisible(false)}
        secondaryButton
        buttonText="Alterar"
        disabled={!revocationReason?.value}
      >
        <>
          <Dropdown
            label="Motivo da rescisão"
            width="100%"
            values={combos?.revocationReasonsList}
            selectedValues={[revocationReason]}
            onChangeValue={onSelectEvocation}
            maxWidth="100%"
            minWidth="100%"
            //padding={{ top: '0.5em' }}
            flex={1}
            closeMenuOnSelect={true}
            menuPosition="fixed"
            labelProps={{
              padding: { top: "1em", bottom: "0.5em" },
              size: "1em",
            }}
          />
          <DatePicker
            label="Data da rescisão"
            // placeholder={'data de rescisão'}
            onChangeValue={onDateSelect}
            value={revocationDate}
            readOnlyHandler={true}
            width="100%"
            //dateFormat={dateFormat}
            //popperPlacement='top-end'
            labelProps={{
              padding: { top: "1em", bottom: "0.5em" },
              size: "1em",
            }}
          />
        </>
      </Dialog>
    );
  };

  const StatusChangeConfirmationDialog = () => {
    const onSubmit = () => {
      statusChangeHandler();
    };

    return (
      <Dialog
        title="Mudança de Status"
        text="Deseja alterar o status atual do contrato?"
        isVisible={isStatusDialogVisible}
        setIsVisible={setIsStatusDialogVisible}
        onClick={onSubmit}
        secondaryButtonOnClick={() => setIsStatusDialogVisible(false)}
        secondaryButton
        buttonText="Alterar"
      ></Dialog>
    );
  };

  useEffect(() => dispatch(loadAllCombos()), [dispatch]);

  return (
    <PageView>
      <Col
        align={{ horizontal: "flex-start", vertical: "flex-start" }}
        flex={1}
        height="99%"
      >
        <Text type="title" color={colors.darkGrey} padding={{ bottom: "1em" }}>
          Contratos cadastrados
        </Text>
        {/* eslint-disable-next-line react/style-prop-object */}
        <Button
          sptyle="submit"
          viewStyle={{ padding: { bottom: "1em" }, align: "flex-start" }}
          onClickFunction={() => history.push("contratos/novo")}
        >
          Adicionar contrato
        </Button>

        <Table
          data={dataSource}
          limit={limit}
          columns={[
            {
              name: "id",
              header: "#",
              type: "number",
              defaultFlex: 1,
              defaultVisible: false,
            },
            { name: "customerName", defaultFlex: 4, header: "Estagiário" },
            { name: "companyName", defaultFlex: 4, header: "Empresa" },
            { name: "schoolName", defaultFlex: 4, header: "Escola" },
            { name: "wage", defaultFlex: 2, header: "Valor da bolsa (R$)" },
            {
              name: "startDate",
              defaultFlex: 2,
              filterType: "date",
              header: "Data de início",
            },
            {
              name: "endDate",
              defaultFlex: 2,
              filterType: "date",
              header: "Data de término",
            },
            {
              name: "status",
              defaultFlex: 4,
              filterType: "select",
              // multiple: true,
              // wrapMultiple: false,
              filterEditorProps: {
                placeholder: "Todos",
                dataSource: statusLOV, //combos?.status
              },
              header: "Status",
              render: ({ data, columnIndex, rowIndex }) => (
                <StatusDropdownComponent
                  data={data}
                  columnIndex={columnIndex}
                  rowIndex={rowIndex}
                />
              ),
            },
            {
              name: "action",
              width: 20,
              header: "",
              sortable: false,
              render: ({ data }) => <ActionComponent data={data} />,
            },
          ]}
          defaultFilterValues={defaultFilterValues}
          sortable
          pagination={true}
          onFilterValueChange={setNewFilterValue}
          onLimitChange={setLimit}
          showColumnMenuTool={true}
          showEmptyRows={true}
          editable={true}
          onReady={setGridRef}
        />
      </Col>

      <EvaluationDialog />
      <TerminationCalcDialog />
      <PayslipDialog />
      <ExtendContractDialog />
      <RevocationDialog />
      <StatusChangeConfirmationDialog />
    </PageView>
  );
};

export default Contrato;
